<!-- @format -->

<agreement-tag>
<style>
.alert {
  color:red;
}
</style>

  <div class="contents">
    
    <section class="contents_area">
      <div class="contents_block detail" style="text-align:center">

      <img src="/assets/img/logo.svg" style="width:300px" />

          <div class="container_news-title" style="margin-top: 32px">ご利用規約</div><!--/.container_news-title-->
          
          <div style="text-align:center; width: 100%">
            <div if={state.now_date <= 20220331} class="contents_block detail" style="padding: 1em ;margin: 0 auto; text-align: left;width:70%;height:300px; overflow-y: scroll; border: 1px solid #000">
              <rules-content-tag></rules-content-tag>
            </div>
              <div if={state.now_date >= 20220401} class="contents_block detail" style="padding: 1em ;margin: 0 auto; text-align: left;width:70%;height:300px; overflow-y: scroll; border: 1px solid #000">
                  <rules-content-tag20220401></rules-content-tag20220401>
              </div>
          </div>

  <div style="margin-top: 20px;">
								<input type="checkbox" value="agree" name="rules" id="rules" class="checkbox-input">
								<label for="rules" class="checkbox-parts">規約に同意します</label>
  </div>
  <div style="margin-top: 10px;">

								<input type="checkbox" value="agree" name="privacy" id="privacy" class="checkbox-input">
								<label for="privacy" class="checkbox-parts">「<a href="https://cro-co.co.jp/privacypolicy/agreement/" target="_blank">個人情報の取り扱い</a>」に同意します</label>



  </div>


        <div class="box_flex03 margin-spacing-3_top">
          <div class="button button-secondary-large" type="button" value="新規登録停止中" data-target="">新規登録停止中</div>
        </div>
      </div><!--/.contents_block-->

    </section><!--/.contents_area-->
    
  </div><!--/.contents-->

<script>
  import di from "dependency-injection";
  import rulesTag from '@tags/parts/edilent-worker-rules.riot';
  import rulesTag20220401after from '@tags/parts/edilent-worker-rules20220401after.riot';
  export default {
    components: {
      "rules-content-tag": rulesTag,
      "rules-content-tag20220401": rulesTag20220401after,
    },
    state:{
      now_date : null,
    },
    register(e) {
      alert('新規登録は停止中です');
    },
    onBeforeMount(props){
      this.Api = di.createApi('register');

      let date = new Date();
      let month = (date.getMonth() + 1 <= 9) ? "0" + (date.getMonth() + 1).toString() : date.getMonth().toString();
      let day = (date.getDate()  <= 9) ? "0" + (date.getDate()).toString() : date.getDate().toString();
      this.state.now_date = parseInt( date.getFullYear() + month + day );
    }
  }
</script>
</agreement-tag>
